import React, { useEffect, useState, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import axios from "axios";
import { Divider, Spin } from "antd";
import { Link } from "react-router-dom";
import { URL_BASE } from "../../config/url-server";

const MapFarm = () => {

    const [centerMap, setCenterMap] = useState([
        10.5582770671,
        -74.1915922693
    ]);

    const clientId = localStorage.getItem("client");
    const accessToken = localStorage.getItem("token");
    const farmId = localStorage.getItem("farmId");
    const farmName = localStorage.getItem("farmName");

    const [mapData, setMapData] = useState(null);
    const [loading, setLoading] = useState(false);

    // Polígono general de la finca
    const [existingPolygon, setExistingPolygon] = useState(null);

    // Captura manual del polígono de finca
    const [capturingPoints, setCapturingPoints] = useState(false);
    const [manualPoints, setManualPoints] = useState([]);

    const [polygonLayer, setPolygonLayer] = useState(null);
    const [existingPolygonLayer, setExistingPolygonLayer] = useState(null);

    const mapRef = useRef(null);

    // =========================================================
    // ACTIVAR / DESACTIVAR MODO CAPTURA
    // =========================================================

    const toggleCaptureMode = () => {

        if (capturingPoints) {

            setCapturingPoints(false);
            setManualPoints([]);

            if (polygonLayer) {
                polygonLayer.remove();
                setPolygonLayer(null);
            }

        } else {

            setCapturingPoints(true);
            setManualPoints([]);

            if (polygonLayer) {
                polygonLayer.remove();
                setPolygonLayer(null);
            }
        }
    };

    // =========================================================
    // DIBUJAR POLIGONO TEMPORAL
    // =========================================================

     const drawTempPolygon = (points, map) => {
               if (polygonLayer) {
                   polygonLayer.remove();
               }
       
               if (points.length >= 2) {
                   const polygon = L.polyline(points, {
                       color: '#00ccff',
                       weight: 5,
                       opacity: 1,
                        dashArray: "8, 8",
                       interactive: false,
                       bubblingMouseEvents: false
                   }).addTo(map);
       
                   setPolygonLayer(polygon);
               }
           };

    // =========================================================
    // CLICK EN MAPA PARA CAPTURAR POLIGONO DE FINCA
    // =========================================================

    // Función para manejar el click en el mapa
    const handleMapClick = (e, map) => {
        if (!capturingPoints) return;

        const { lat, lng } = e.latlng;
        const newPoint = [lat, lng];

        setManualPoints(prev => {
            const updatedPoints = [...prev, newPoint];

            // Dibujar polígono temporal si tenemos suficientes puntos
            if (updatedPoints.length >= 2) {
                drawTempPolygon(updatedPoints, map);
            }

            return updatedPoints;
        });

        // Añadir marcador visual del punto
         const marker = L.circleMarker([lat, lng], {
                    radius: 6,
                    color: '#0077ff',
                    weight: 2,
                    fillColor: '#a3e6b9',
                    fillOpacity: 5,
                    interactive: true,
                    bubblingMouseEvents: true
                }).addTo(map);

        marker.bindPopup(`Punto ${manualPoints.length + 1}<br/>Lat: ${lat}<br/>Lng: ${lng}`);

        // Guardar referencia para eliminarlo después si es necesario
        setTimeout(() => {
            if (!capturingPoints) {
                marker.remove();
            }
        }, 30000);
    };

    // =========================================================
    // FINALIZAR Y GUARDAR POLIGONO DE FINCA
    // =========================================================

    const finishPolygon = async () => {

        if (manualPoints.length < 3) {

            alert(
                "Necesitas al menos 3 puntos para crear un polígono"
            );

            return;
        }

        // Cerrar polígono
        const closedPoints = [
            ...manualPoints,
            manualPoints[0]
        ];

        // Convertir [lat,lng] -> [lng,lat]
        const geoJsonCoordinates =
            closedPoints.map(
                point => [
                    point[1],
                    point[0]
                ]
            );

        const polygonData = {

            polygon: {
                type: "Polygon",
                coordinates: [
                    geoJsonCoordinates
                ]
            },

            farmId: farmId
        };

        console.log(
            "Guardando polígono:",
            polygonData
        );

        try {

            const config = {

                headers: {
                    client: clientId,
                    Authorization: `Bearer ${accessToken}`
                }

            };

            const response =
                await axios.post(
                    URL_BASE +
                    "farm/update-polygon",
                    polygonData,
                    config
                );

            if (response.data.success) {

                alert(
                    "Polígono guardado exitosamente"
                );

                if (polygonLayer) {

                    polygonLayer.setStyle({
                        color: "#4caf50",
                        fillOpacity: 0.2,
                        dashArray: null,
                        interactive: false,
                        bubblingMouseEvents: false
                    });
                }

                if (existingPolygonLayer) {
                    existingPolygonLayer.remove();
                }

                setExistingPolygon(
                    polygonData.polygon
                );

                drawExistingPolygon(
                    mapRef.current,
                    polygonData.polygon
                );
            }

            setCapturingPoints(false);
            setManualPoints([]);

        } catch (error) {

            console.error(
                "Error guardando polígono:",
                error
            );

            alert(
                "Error al guardar el polígono: " +
                (
                    error.response?.data?.message ||
                    error.message
                )
            );
        }
    };

    // =========================================================
    // DIBUJAR POLIGONO GENERAL DE LA FINCA
    // =========================================================

    const drawExistingPolygon = (
        map,
        polygon
    ) => {

        if (
            !map ||
            !polygon ||
            !polygon.coordinates ||
            !polygon.coordinates[0]
        ) {
            return null;
        }

        try {

            if (existingPolygonLayer) {
                existingPolygonLayer.remove();
            }

            // GeoJSON [lng,lat]
            // Leaflet [lat,lng]

            const latLngPoints =
                polygon.coordinates[0].map(
                    coord => [
                        coord[1],
                        coord[0]
                    ]
                );

            const polygonLayerNew =
                L.polygon(
                    latLngPoints,
                    {
                        color: "#59f13b",
                        weight: 5,
                        opacity: 0.8,
                        fillColor: "#59f13b",
                        fillOpacity: 0,
                        dashArray: "8, 8",
                        className: "existing-polygon",
                        interactive: false,
                        bubblingMouseEvents: false
                    }
                ).addTo(map);

            polygonLayerNew.bindTooltip(
                "Límite de la Finca",
                {
                    sticky: true,
                    direction: "center"
                }
            );

            setExistingPolygonLayer(
                polygonLayerNew
            );

            return polygonLayerNew;

        } catch (error) {

            console.error(
                "Error dibujando polígono existente:",
                error
            );

            return null;
        }
    };

    // =========================================================
    // DIBUJAR POLIGONO DEL LOTE
    // =========================================================

    const drawLotPolygon = (
        map,
        lot,
        color
    ) => {

        if (
            !map ||
            !lot?.lotPolygon?.coordinates?.[0]
        ) {
            return null;
        }

        try {

            const coordinates =
                lot.lotPolygon.coordinates[0];

            // GeoJSON:
            // [lng, lat]

            // Leaflet:
            // [lat, lng]

            const latLngPoints =
                coordinates.map(
                    ([lng, lat]) => [
                        lat,
                        lng
                    ]
                );

            const lotPolygon =
                L.polygon(
                    latLngPoints,
                    {
                        color: color,
                        weight: 2,
                        opacity: 0.9,
                        fillColor: color,
                        fillOpacity: 0.30,
                        interactive: false,
                        bubblingMouseEvents: false
                    }
                ).addTo(map);

            lotPolygon.bindTooltip(
                `<label style='font-size:8px'>${lot.name}</label>`,
                {
                    permanent: true,
                    direction: "center",
                    className: "lot-label",
                    opacity: 1
                }
            );

            return lotPolygon;

        } catch (error) {

            console.error(
                `Error dibujando polígono del lote ${lot.name}:`,
                error
            );

            return null;
        }
    };

    // =========================================================
    // EDITAR POLIGONO DE FINCA
    // =========================================================


    // =========================================================
    // ELIMINAR POLIGONO DE FINCA
    // =========================================================

    const deletePolygon = async () => {

        if (
            !window.confirm(
                "¿Estás seguro de que deseas eliminar el polígono de esta finca?"
            )
        ) {
            return;
        }

        try {

            const config = {

                headers: {
                    client: clientId,
                    Authorization: `Bearer ${accessToken}`
                },

                data: {
                    farmId: farmId
                }
            };

            const response =
                await axios.delete(
                    URL_BASE +
                    "farm/delete-polygon",
                    config
                );

            if (response.data.success) {

                alert(
                    "Polígono eliminado exitosamente"
                );

                if (existingPolygonLayer) {

                    existingPolygonLayer.remove();

                    setExistingPolygonLayer(
                        null
                    );
                }

                setExistingPolygon(null);
            }

        } catch (error) {

            console.error(
                "Error eliminando polígono:",
                error
            );

            alert(
                "Error al eliminar el polígono"
            );
        }
    };

    // =========================================================
    // GENERAR COLORES DE LOTES
    // =========================================================

    const generateLotColors = lots => {

        const colors = {};

        const predefinedColors = [
            "#e91e63",
            "#9c27b0",
            "#673ab7",
            "#3f51b5",
            "#2196f3",
            "#009688",
            "#4caf50",
            "#8bc34a",
            "#ff9800",
            "#ff5722",
            "#795548",
            "#607d8b"
        ];

        lots.forEach(
            (lot, index) => {

                colors[lot.name] =
                    predefinedColors[
                    index %
                    predefinedColors.length
                    ];
            }
        );

        return colors;
    };

    // =========================================================
    // CARGAR POLIGONOS
    // =========================================================

    const loadLotPositions = async () => {

        setLoading(true);

        try {

            const params = {
                farmId
            };

            const config = {

                headers: {
                    client: clientId,
                    Authorization: `Bearer ${accessToken}`
                },

                params
            };

            const response =
                await axios.get(
                    URL_BASE +
                    "map/get-farm-polygons",
                    config
                );

            console.log(
                "Respuesta mapa:",
                response.data
            );

            const lots =
                response.data.data || [];

            const farmPolygon =
                response.data.polygon || null;

            console.log(
                "Lotes:",
                lots
            );

            console.log(
                "Polígono finca:",
                farmPolygon
            );

            // -------------------------------------------------
            // POLIGONO GENERAL DE LA FINCA
            // -------------------------------------------------

            const hasValidFarmPolygon =
                farmPolygon &&
                farmPolygon.coordinates &&
                farmPolygon.coordinates.length > 0 &&
                farmPolygon.coordinates[0]?.length > 0;

            if (hasValidFarmPolygon) {

                setExistingPolygon(
                    farmPolygon
                );

                // Centrar mapa con el polígono de la finca

                const coords =
                    farmPolygon.coordinates[0];

                const sumLat =
                    coords.reduce(
                        (sum, coord) =>
                            sum + coord[1],
                        0
                    );

                const sumLng =
                    coords.reduce(
                        (sum, coord) =>
                            sum + coord[0],
                        0
                    );

                const centerLat =
                    sumLat /
                    coords.length;

                const centerLng =
                    sumLng /
                    coords.length;

                setCenterMap([
                    centerLat,
                    centerLng
                ]);

            } else {

                setExistingPolygon(
                    null
                );
            }

            // -------------------------------------------------
            // COLORES
            // -------------------------------------------------

            const lotColors =
                generateLotColors(
                    lots
                );

            console.log(
                "Colores de lotes:",
                lotColors
            );

            // -------------------------------------------------
            // GUARDAR DATOS
            // -------------------------------------------------

            setMapData({
                lots,
                lotColors
            });

        } catch (error) {

            console.error(
                "Error obteniendo los polígonos:",
                error
            );

        } finally {

            setLoading(false);
        }
    };

    // =========================================================
    // CARGAR INFORMACION INICIAL
    // =========================================================

    useEffect(() => {

        loadLotPositions();

    }, []);

    // =========================================================
    // CREAR MAPA
    // =========================================================

    useEffect(() => {

        if (!mapData) {
            return;
        }

        const {
            lots,
            lotColors
        } = mapData;

        // -----------------------------------------------------
        // CREAR MAPA
        // -----------------------------------------------------

        const map =
            L.map(
                "map",
                {
                    center: centerMap,
                    zoom: 16
                }
            );

        mapRef.current =
            map;

        // -----------------------------------------------------
        // CAPA SATELITAL
        // -----------------------------------------------------

        L.tileLayer(
            "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
            {
                attribution:
                    "Tiles © Esri — Source: Esri, USDA, USGS, AEX, GeoIQ, and the GIS Community"
            }
        ).addTo(map);

        // -----------------------------------------------------
        // CLICK PARA CAPTURA
        // -----------------------------------------------------

        if (capturingPoints) {

            map.on(
                "click",
                e =>
                    handleMapClick(
                        e,
                        map
                    )
            );
        }

        // -----------------------------------------------------
        // DIBUJAR POLIGONOS DE LOTES
        // -----------------------------------------------------

        lots.forEach(
            lot => {

                const color =
                    lotColors[
                    lot.name
                    ];

                drawLotPolygon(
                    map,
                    lot,
                    color
                );
            }
        );

        // -----------------------------------------------------
        // DIBUJAR POLIGONO GENERAL DE FINCA
        // -----------------------------------------------------

        if (
            existingPolygon &&
            existingPolygon.coordinates &&
            existingPolygon.coordinates[0]
        ) {

            drawExistingPolygon(
                map,
                existingPolygon
            );
        }

        // -----------------------------------------------------
        // CLEANUP
        // -----------------------------------------------------

        return () => {

            if (mapRef.current) {

                mapRef.current.remove();

                mapRef.current = null;
            }
        };

    }, [
        mapData,
        existingPolygon,
        capturingPoints
    ]);

    // =========================================================
    // ACTUALIZAR EVENTO CLICK
    // =========================================================

    useEffect(() => {

        if (!mapRef.current) {
            return;
        }

        const map =
            mapRef.current;

        map.off("click");

        if (capturingPoints) {

            map.on(
                "click",
                e =>
                    handleMapClick(
                        e,
                        map
                    )
            );
        }

    }, [
        capturingPoints
    ]);

    // =========================================================
    // UI
    // =========================================================

    return (

        <div>

            <Spin spinning={loading}>

                <div
                    className="col-12"
                    style={{
                        marginTop: "-10px"
                    }}
                >

                    <Divider
                        orientation="left"
                        style={{
                            borderColor: "#AAAAAA"
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px"
                            }}
                        >
                            <span>FINCA: {farmName}</span>

                            <Link
                                to="/admin-farms"
                                className="nav-link link-primary p-1"
                            >
                                <i className="bi bi-arrow-left-short fa-lg"></i>

                                <span className="fs-6 m-1">
                                    <strong>
                                        REGRESAR A FINCAS
                                    </strong>
                                </span>
                            </Link>
                        </div>
                    </Divider>

                    <div className="col-12 mb-3">

                        <div
                            className="d-flex gap-2 align-items-center flex-wrap"
                        >

                            <button
                                className={
                                    `btn ${capturingPoints
                                        ? "btn-danger"
                                        : "btn-primary"
                                    }`
                                }
                                onClick={
                                    toggleCaptureMode
                                }
                            >

                                {
                                    capturingPoints
                                        ? "Cancelar Captura"
                                        : "Capturar Nuevo Polígono"
                                }

                            </button>

                            {
                                existingPolygon &&
                                !capturingPoints && (

                                    <>

                                        <button
                                            className="btn btn-danger"
                                            onClick={
                                                deletePolygon
                                            }
                                        >
                                            Eliminar Polígono
                                        </button>

                                    </>
                                )
                            }

                            {
                                capturingPoints && (

                                    <>

                                        <span
                                            className="badge bg-info"
                                        >
                                            Puntos:{" "}
                                            {
                                                manualPoints.length
                                            }
                                            {" "}
                                            (mínimo 3)
                                        </span>

                                        <button
                                            className="btn btn-success"
                                            onClick={
                                                finishPolygon
                                            }
                                            disabled={
                                                manualPoints.length < 3
                                            }
                                        >
                                            Finalizar y Guardar
                                        </button>



                                    </>
                                )
                            }

                        </div>

                        {
                            capturingPoints && (

                                <div
                                    className="alert alert-info mt-2"
                                >

                                    <i className="bi bi-info-circle"></i>

                                    {" "}

                                    <strong>
                                        Modo captura activado:
                                    </strong>

                                    {" "}
                                    Haz clic en el mapa para añadir
                                    puntos del polígono.

                                </div>
                            )
                        }

                        {
                            existingPolygon &&
                            !capturingPoints
                        }

                        {
                            !existingPolygon &&
                            !capturingPoints && (

                                <div
                                    className="alert alert-warning mt-2"
                                >

                                    <i className="bi bi-exclamation-triangle"></i>

                                    {" "}

                                    Esta finca no tiene polígono
                                    definido.

                                    Usa el botón
                                    "Capturar Nuevo Polígono"
                                    para crear uno.

                                </div>
                            )
                        }

                    </div>

                </div>

                <div
                    id="map"
                    style={{
                        height: "600px",
                        width: "100%",
                        borderRadius: "8px"
                    }}
                />

            </Spin>

        </div>
    );
};

export default MapFarm;